module.exports = __webpack_public_path__ + "img/user3.1334b812.jpg";